export default __webpack_public_path__ + "static/ogp-93bb7accfd277707a4b700b45945f111.jpg";